import { MRT_ColumnDef } from 'mantine-react-table'
import React from 'react'
import { useParams } from 'react-router-dom'
import CountryDetail from 'src/containers/CountryDetail'
import { useNavigate } from 'react-router-dom'

function CountryDetailPage() {
	const params = useParams()
	const { name } = params
	const navigate = useNavigate()


	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'name',
			header: 'Name',
		},
		{
			accessorKey: 'last_login_at',
			header: 'Last login at',
		},
	]
	const fields = [
		{
			value: 'name',
			label: 'Name',
		},
	]

	const handleDetail = (row) => {
		navigate(`/users/${row?.original?.id}`)
	}

	return <CountryDetail name={name} columns={columns} fields={fields} handleDetail={handleDetail} />
}

export default React.memo(CountryDetailPage)
